export const disableWebpackCdnPublicPath = (callback: () => unknown) => {
  const oldPublicPath = __webpack_public_path__;
  __webpack_public_path__ = "/dist/";
  callback();
  __webpack_public_path__ = oldPublicPath;
};
